import React from 'react';
import { Box, Typography } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import rgba from 'assets/theme/function/rgba';
import colors from 'assets/theme/base/colors';
import borders from 'assets/theme/base/borders';
import typography from 'assets/theme/base/typography';
import { API_ENDPOINT_URL } from 'constant';
import { useNavigate } from 'react-router-dom';
import { TeamDetailsResponse } from 'types/team/team';

interface Props {
    data?: TeamDetailsResponse;
}

const TeamParams: React.FC<Props> = ({ data }) => {
    const navigate = useNavigate();

    return (
        <Box
            ml={pxToRem(15)}
            flexBasis={'85%'}
            border={`1px solid ${rgba(colors.info.main, 0.5)}`}
            borderRadius={borders.borderRadius.md}
            p={pxToRem(8)}
            display={'flex'}
            justifyContent={'center'}
            gap={2}
        >
            <Box display="grid" width="100%">
                {[
                    ['Team Name :', data?.title],
                    ['Team Score :', data?.teamScore],
                ].map(([label, value]) => (
                    <Box
                        key={label}
                        display="grid"
                        gridTemplateColumns="250px 1fr"
                        alignItems="center"
                        borderBottom={`1px solid ${rgba(colors.info.main, 0.5)}`}
                        p={pxToRem(5)}
                    >
                        <Typography
                            variant="h6"
                            fontWeight={typography.fontWeightMedium}
                        >
                            {label}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            fontWeight={typography.fontWeightLight}
                        >
                            {value}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <Box display="grid" width="100%">
                {[
                    ['Team Status:', data?.teamStatus],
                    ['Team Type:', data?.teamType],
                ].map(([label, value]) => (
                    <Box
                        key={label}
                        display="grid"
                        gridTemplateColumns="250px 1fr"
                        alignItems="center"
                        borderBottom={`1px solid ${rgba(colors.info.main, 0.5)}`}
                        p={pxToRem(5)}
                    >
                        <Typography
                            variant="h6"
                            fontWeight={typography.fontWeightMedium}
                        >
                            {label}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            fontWeight={typography.fontWeightLight}
                        >
                            {value}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <Box display="grid" width="100%">
                {[
                    ['Team User Count:', data?.teamUserCount],
                    ['Team Leader Name:', data?.teamLeaderNickname],
                ].map(([label, value, img]) => (
                    <Box
                        key={label}
                        display="grid"
                        gridTemplateColumns="250px 1fr"
                        alignItems="center"
                        borderBottom={`1px solid ${rgba(colors.info.main, 0.5)}`}
                        p={pxToRem(5)}
                    >
                        <Typography
                            variant="h6"
                            fontWeight={typography.fontWeightMedium}
                        >
                            {label}
                        </Typography>
                        <Box display={'flex'} alignItems="center">
                            <Typography
                                variant="subtitle1"
                                fontWeight={typography.fontWeightLight}
                            >
                                {value}
                            </Typography>
                            {img && (
                                <Box
                                    component="img"
                                    src={`${API_ENDPOINT_URL}/avatar/file/${img}`}
                                    alt=""
                                    sx={{
                                        cursor: 'pointer',
                                        width: 25,
                                        height: 25,
                                        borderRadius: borders.borderRadius.md,
                                        ml: pxToRem(10),
                                    }}
                                    onClick={() => navigate(`/team-info`)}
                                />
                            )}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default TeamParams;
